import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import NotFoundPage from "@/pages/NotFoundPage";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App" data-testid="app-root">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </div>
    </HelmetProvider>
  );
}

export default App;
